// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_pulls_model from "./web_pulls_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Int from "melange/int.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function checks(param) {
  switch (param) {
    case "behind" :
      return "The branch is behind its target.";
    case "blocked" :
      return "GitHub branch rules block merging.";
    case "clean" :
      return "Checks and branch rules allow merging.";
    case "dirty" :
      return "Merge conflicts must be resolved.";
    case "unstable" :
      return "Some checks are pending or failing.";
    default:
      return "Review the current checks on GitHub.";
  }
}

function file_row(source) {
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___001_) {
      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (f) {
        return f.path;
      }), source)));
      return function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___002_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (f) {
          return f.patch;
        }), source)));
        const partial_arg$1 = "pull-patch";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$1 = "environment-version";
  const partial_arg$2 = 0;
  const partial_arg$3 = 12;
  const partial_arg$4 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, param, param$1);
  };
}

function review(model, source, send) {
  const partial_arg = Signal.map((function (p) {
    return p.detail;
  }), source);
  return function (param, param$1) {
    return Lui_elements.dyn(undefined, (function (selected) {
      if (selected === undefined) {
        return function (param, param$1) {
          return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }
      const partial_arg = "PR #" + (String(selected.pull.number) + (": " + selected.pull.title));
      const partial_arg$1 = 3;
      const partial_arg$2 = "Target: " + (selected.pull.base + (" / " + Stdlib__String.sub(selected.pull.head, 0, Caml.caml_int_min(12, selected.pull.head.length))));
      const partial_arg$3 = selected.pull.draft ? "Draft PR" : (
          Caml_obj.caml_equal(selected.pull.mergeable, true) ? "No conflicts" : (
              Caml_obj.caml_equal(selected.pull.mergeable, false) ? "Merge conflicts" : "GitHub is checking mergeability."
            )
        );
      const partial_arg$4 = checks(selected.pull.checks);
      const partial_arg$5 = "muted";
      const partial_arg$6 = Signal.map((function (p) {
        return Stdlib__Option.fold(/* [] */ 0, (function (d) {
          return d.files;
        }), p.detail);
      }), source);
      let tmp;
      if (selected.truncated) {
        const partial_arg$7 = "This PR has more files. Review the complete diff on GitHub.";
        tmp = (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        });
      } else {
        tmp = (function (param, param$1) {
          return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        });
      }
      const partial_arg$8 = "View PR on GitHub";
      const partial_arg$9 = "blank";
      const partial_arg$10 = selected.pull.url;
      const partial_arg$11 = {
        TAG: /* Pulls */ 35,
        _0: /* Submit */ 3
      };
      const partial_arg$12 = (function (param) {
        return Lui_elements.press(send, partial_arg$11, param);
      });
      const partial_arg$13 = "primary";
      const partial_arg$14 = "Merge PR #" + (String(selected.pull.number) + (" into " + selected.pull.base));
      const partial_arg$15 = function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
      const partial_arg$16 = Signal.map(Mapre_web__Web_pulls_model.can_submit, source);
      const partial_arg$17 = function (param, param$1) {
        return Lui_elements.if_(partial_arg$16, partial_arg$15, param, param$1);
      };
      const partial_arg$18 = Signal.map(Mapre_web__Web_model.can_create, model);
      const partial_arg_0 = function (param, param$1) {
        return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
      const partial_arg_1 = {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.keyed(partial_arg$6, (function (f) {
                  return f.path;
                }), Stdlib__String.compare, file_row, param, param$1);
              }),
              tl: {
                hd: tmp,
                tl: {
                  hd: (function (param, param$1) {
                    return Lui_elements.link(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, partial_arg$9, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  }),
                  tl: {
                    hd: (function (param, param$1) {
                      return Lui_elements.if_(partial_arg$18, partial_arg$17, param, param$1);
                    }),
                    tl: /* [] */ 0
                  }
                }
              }
            }
          }
        }
      };
      const partial_arg$19 = {
        hd: partial_arg_0,
        tl: partial_arg_1
      };
      const partial_arg$20 = 0;
      const partial_arg$21 = 12;
      return function (param, param$1) {
        return Lui_elements.column(undefined, partial_arg$21, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$20, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$19, param, param$1);
      };
    }), partial_arg, param, param$1);
  };
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return Stdlib__Option.value(m.pulls_form, Mapre_web__Web_pulls_model.initial(""));
  }), model);
  const partial_arg = "Project pull requests";
  const partial_arg$1 = 2;
  const partial_arg$2 = Signal.map((function (p) {
    return p.pulls;
  }), source);
  const partial_arg$3 = {
    TAG: /* Pulls */ 35,
    _0: /* More */ 2
  };
  const partial_arg$4 = (function (param) {
    return Lui_elements.press(send, partial_arg$3, param);
  });
  const partial_arg$5 = "outline";
  const partial_arg$6 = "More pull requests";
  const partial_arg$7 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$8 = Signal.map((function (p) {
    return p.next_page !== undefined;
  }), source);
  const partial_arg$9 = {
    TAG: /* Pulls */ 35,
    _0: /* Close */ 0
  };
  const partial_arg$10 = (function (param) {
    return Lui_elements.press(send, partial_arg$9, param);
  });
  const partial_arg$11 = "ghost";
  const partial_arg$12 = "Close pull requests";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___004_) {
      const partial_arg = {
        TAG: /* Pulls */ 35,
        _0: /* Refresh */ 1
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (p) {
        return p.pending;
      }), source)));
      const partial_arg$3 = "outline";
      const partial_arg$4 = "Refresh PR status";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$8, partial_arg$7, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$13 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$14 = "wrap";
  const partial_arg$15 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___003_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map(Mapre_web__Web_pulls_model.progress, source)));
        const partial_arg$1 = "notice";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.keyed(partial_arg$2, (function (p) {
          return p.number;
        }), Stdlib__Int.compare, (function (signal) {
          return function (param, param$1) {
            return Lui_elements.dyn(undefined, (function (pull) {
              const partial_arg = pull.title;
              const partial_arg$1 = {
                TAG: /* Pulls */ 35,
                _0: {
                  TAG: /* Review */ 1,
                  _0: pull.number
                }
              };
              const partial_arg$2 = (function (param) {
                return Lui_elements.press(send, partial_arg$1, param);
              });
              const partial_arg$3 = "outline";
              const partial_arg$4 = "Review PR #" + String(pull.number);
              const partial_arg_0 = function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
              const partial_arg_1 = {
                hd: (function (param, param$1) {
                  return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                }),
                tl: /* [] */ 0
              };
              const partial_arg$5 = {
                hd: partial_arg_0,
                tl: partial_arg_1
              };
              const partial_arg$6 = "wrap";
              const partial_arg$7 = 8;
              return function (param, param$1) {
                return Lui_elements.row(undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, partial_arg$5, param, param$1);
              };
            }), signal, param, param$1);
          };
        }), param, param$1);
      }),
      tl: {
        hd: review(model, source, send),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.row(undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, undefined, partial_arg$13, param, param$1);
          }),
          tl: /* [] */ 0
        }
      }
    }
  };
  const partial_arg$16 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$17 = "form-card";
  const partial_arg$18 = 0;
  const partial_arg$19 = 16;
  const partial_arg$20 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$20, undefined, undefined, undefined, undefined, undefined, partial_arg$19, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
